import { useState } from "react";
import request from "project-config/services/request/request";
import { useProjectStore } from "../store/project-store";
import { message } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function useDeleteProject() {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { fetchProjectData } = useProjectStore();
  const t = getTranslateNsT("center");
  async function handleDelete(delName: string) {
    const res = await request.post(
      "/api/rendering/task/common/operateUserLabel",
      {
        delName,
        type: 2,
      }
    );
    if (res.code === 605) {
      message.error(
        t("user_com_childPro_render_btn_vinsufficient_permissions")
      );
      return;
    }
    if (res.code === 200) {
      message.success(t("user_com_childPro_render_del_btn_success"));
      fetchProjectData();
    }
    setOpenDeleteModal(false);
  }
  return {
    openDeleteModal,
    setOpenDeleteModal,
    handleDelete,
  };
}
